<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="sigil_not_in_toc"><span epub:type="pagebreak" id="pagev" title="v"></span></h1>
<h6 class="sigil_not_in_toc">FROM STEWART KELLY:</h6>
<p class="firstcenter"><i>In honor of Shirley Lachs, for her kindness, generosity, and encouragement</i></p>
<p class="firstcenter"><br/></p>
<h6 class="sigil_not_in_toc">FROM JAMES DEW:</h6>
<p class="firstcenter"><i>To TD and the Dew Crew—my greatest joys this side of heaven</i></p>
<p class="first"><span epub:type="pagebreak" id="pagevi" title="vi"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?6536cfc7